<template>
  <div>
    <div class="columns">
      <div class="column">
        <h2 class="title is-3">Аккаунты leadsu</h2>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <b-button
          class="is-pulled-right"
          type="is-primary"
          icon-right="plus"
          @click="createAccountLeadsu">
          Добавить аккаунт</b-button>
      </div>
    </div>

    <!-- ТАБЛИЦА -->
    <b-table
      :data="leadsu_accounts"
      class="users-table"
    >
      <b-table-column v-slot="props">
        <span>{{ props.row.is_favorite ? '⭐' : '' }}</span>
      </b-table-column>

<!--      <b-table-column label="ID" v-slot="props">-->
<!--        <span>{{ props.row.id }}</span>-->
<!--      </b-table-column>-->

      <b-table-column label="Leadsu ID" v-slot="props">
        <span>{{ props.row.leadsu_id }}</span>
      </b-table-column>

      <b-table-column label="Имя" v-slot="props">
        <span>{{ props.row.name }}</span>
      </b-table-column>

      <b-table-column label="Действия" v-slot="props">

        <b-tooltip label="Редактировать">
          <b-button class="edit_icon" @click="updateLeadsuAccount(props.row.id)">
            <svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 20h4l10.5 -10.5a1.5 1.5 0 0 0 -4 -4l-10.5 10.5v4"></path>
              <path d="M13.5 6.5l4 4"></path>
            </svg>
          </b-button>
        </b-tooltip>

        <b-tooltip label="Удалить">
          <b-button
            class="delete_icon"
            @click="deleteLeadsuAccount(props.row.id)">
            <svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 7l16 0"></path>
              <path d="M10 11l0 6"></path>
              <path d="M14 11l0 6"></path>
              <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
              <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
            </svg>
          </b-button>
        </b-tooltip>

      </b-table-column>

    </b-table>

    <LeadsuDetailsModal/>
    <ConfirmDeletionLeadsuModal/>

    <OverlayLoader :show="isLoading"/>

  </div>
</template>

<script>
import OverlayLoader from "@/app/shared/components/app-loader/Loader";
import LeadsuDetailsModal from "@/app/client/offers_rate/leadsu/shared/modals/leadsuDetailsModal.vue";
import ConfirmDeletionLeadsuModal
  from "@/app/client/offers_rate/leadsu/shared/modals/confirmDeletionLeadsuModal.vue";

export default {
  name: "LeadsuAccounts",
  components: {
    OverlayLoader,
    LeadsuDetailsModal,
    ConfirmDeletionLeadsuModal
  },
  data() {
    return {
    };
  },
  created() {
    this.getLeadsuAccounts();
  },
  watch: {
    detailOpened(newVal) {
      if (!newVal) {
        this.getLeadsuAccounts();
      }
    },
    isOpenConfirmDeletionModalLeadsuAccount(newVal) {
      if (!newVal) {
        this.getLeadsuAccounts();
      }
    }
  },
  computed: {
    leadsu_accounts() {
      return this.$store.getters.GET_LEADSU_ACCOUNTS;
    },
    isLoading: {
      get() {
        return this.$store.getters.IS_LEADSU_ACCOUNTS_LOADING;
      },
      set(value) {
        this.$store.commit("SET_LEADSU_ACCOUNTS_LOADING", value);
      },
    },
    detailOpened: {
      get() {
        return this.$store.getters.GET_LEADSU_ACCOUNT_DETAILS_MODAL_OPENED;
      },
      set(value) {
        this.$store.commit("SET_LEADSU_ACCOUNT_DETAILS_MODAL_OPENED", value);
      },
    },
    isOpenConfirmDeletionModalLeadsuAccount: {
      get() {
        return this.$store.getters.GET_LEADSU_ACCOUNT_DETAILS_MODAL_CONFIRM_DELETION;
      },
      set(value) {
        this.$store.commit("SET_CONFIRM_DELETION_LEADSU_ACCOUNT_MODAL", value);
      }
    },
  },
  methods: {
    createAccountLeadsu() {
      this.$store.commit("SET_CURRENT_LEADSU_ACCOUNT", {'is_favorite': false});
      this.detailOpened = true;
    },
    updateLeadsuAccount(id) {
      this.$store.dispatch("GET_LEADSU_ACCOUNT_BY_ID", id).then(() => {
        this.detailOpened = true;
      }).catch(() => {
        this.$toast.error("Ошибка при получении данных");
      });
    },
    deleteLeadsuAccount(id) {
      this.$store.dispatch("GET_LEADSU_ACCOUNT_BY_ID", id).then(() => {
        this.isOpenConfirmDeletionModalLeadsuAccount = true;
      }).catch(() => {
        this.$toast.error("Ошибка при получении данных");
      });
    },
    getLeadsuAccounts() {
      this.$store.dispatch("GET_LEADSU_ACCOUNTS").catch(() => {
        this.$toast.error("Ошибка при получении данных");
      });
    },
  },
};
</script>
